export default {
  App: {
    title: 'DeBank | The Real User Based Web3 Community',
    meta: [
      {
        name: 'description',
        content: 'The Real User Based Web3 Community',
      },
      {
        name: 'og:title',
        content: 'DeBank | The Real User Based Web3 Community',
      },
      {
        name: 'og:description',
        content: 'The Real User Based Web3 Community',
      },
      {
        name: 'twitter:description',
        content: 'The Real User Based Web3 Community',
      },
    ],
  },
};

export const getPageTitle = (name: string) =>
  `${name} | DeBank | The Real User Based Web3 Community`;
